import React, { useEffect, useState, useCallback } from "react";
import { Card, CardBody } from "reactstrap";
import { useSelector } from "react-redux";

import Animation from "@areas/shared/components/chooseLayout/Animation";
import animationStyles from "@areas/shared/components/chooseLayout/styles/animations.module.css";
import CustomModal from "@areas/shared/components/personal/modals/CustomModal";
import {
  initialValues,
  validationSchema,
  confirm,
  ModalBodyAdd,
} from "@areas/shared/pages/personal/frames/requests/list-from/blocks/ModalAdd";

import { fetchWrapper } from "@helpers/fetchwrapper";

import Table from "./blocks/Table";

function Frame(props) {
  const { company: currentCompany } = useSelector((x) => x.auth);
  const [showModal, setShowModal] = useState(false);
  const [headerModal, setHeaderModal] = useState("");
  const [request, setRequest] = useState(null);
  const [perPage, setPerPage] = useState(10);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [data, setData] = useState([]);
  const [dataType, setDataType] = useState(1);
  const [load, setLoad] = useState(false);
  const [search, setSearch] = useState("");

  const loadData = useCallback(() => {
    setLoad(true);
    fetchWrapper
      .get(
        `/v1/api/app/allCompany/${dataType}?offset=${
          page * perPage - perPage
        }&limit=${perPage}&text=${search}`
      )
      .then((res) => {
        setData(res.data);
        setTotal(res.total);
        setLoad(false);
      });
  }, [page, perPage, dataType, search]);

  const handleSearch = useCallback((text) => {
    setSearch(text); 
    setPage(1);
  }, []);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const handlePageChange = (page) => {
    setPage(page);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setPerPage(newPerPage);
    setPage(page);
  };

  const toggle = useCallback(() => {
    setShowModal((prev) => {
      if (prev) {
        setRequest(null);
      }
      return !prev;
    });
  }, []);

  const handleCreateRequest = useCallback((row) => {
    setRequest({
      ToIdCompany: row.Id,
      ToCompany: row.Shortname ? row.Shortname : row.Fullname,
    });
    setHeaderModal("Добавление заявки");
    setShowModal(true);
  }, []);

  return (
    <div>
      <Animation
        animationIn={animationStyles.fadeIn}
        animationOut={animationStyles.fadeOut}
      >
        <Card>
          <CardBody>
            <Table
              data={data}
              load={load}
              total={total}
              handlePageChange={handlePageChange}
              handlePerRowsChange={handlePerRowsChange}
              onSearch={handleSearch}
              onCreateRequest={handleCreateRequest}
            />
          </CardBody>
        </Card>
      </Animation>
      <CustomModal
        isOpen={showModal}
        toggle={toggle}
        header={headerModal}
        body={(validation) => <ModalBodyAdd validation={validation} />}
        validateYupSchema={validationSchema}
        inititalValues={() => initialValues(request, currentCompany)}
        cancel="Закрыть"
        confirm="Сохранить"
        confirmFunction={(values) => {
          confirm(values, () => {});
        }}
      />
    </div>
  );
}

export default Frame;
